import { DetailedLoanStatusTag } from '@/components/shared/components/DetailedLoanStatusTag';
import { Text } from '@/components/shared/components/Text';
import { ApplicationType } from '@/config/types';

interface StatusFieldColumnProps {
  applicationType: ApplicationType;
  flex?: number;
  sortable?: boolean;
}

export const statusFieldColumn = ({ applicationType, flex, sortable = true }: StatusFieldColumnProps) => {
  return {
    flex: flex ?? 0.53,
    field: 'status',
    headerName: <Text tId={'STATUS'} />,
    sortable,
    renderCell: (rowData) => (
      <div
        style={{
          minWidth: '120px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          whiteSpace: 'break-spaces',
          width: '100%',
        }}
      >
        <DetailedLoanStatusTag
          loan={rowData.row}
          status={rowData.row.status}
          applicationType={applicationType}
          loanCriteria={rowData.row}
        />
      </div>
    ),
  };
};
